import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6658f5cb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658f5cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6658f5cb')) {
      api.createRecord('6658f5cb', component.options)
    } else {
      api.reload('6658f5cb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6658f5cb&scoped=true", function () {
      api.rerender('6658f5cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/risk/index.vue"
export default component.exports